import { ThemeEvents, VariantUpdateEvent } from '@theme/events';
import { Component } from '@theme/component';

/**
 * <pack-spec data-map='{"<variantId>":"<display text>", …}'>40g pack</pack-spec>
 *
 * Refreshes the variant-level pack spec value when the variant changes. The spec
 * table (bw-spec-table) can render in several sections at once — the main
 * product-information section, a standalone section, and product-detail-columns —
 * but only the variant picker's OWN section re-renders and bubbles variant:update.
 * So we listen on `document` (catching the event wherever it fires) and read the
 * new variant's value from an embedded map, rather than from the re-rendered HTML.
 * If a variant has no pack spec, its row is hidden so we never show a stale value.
 */
class PackSpec extends Component {
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(ThemeEvents.variantUpdate, this.updatePackSpec);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(ThemeEvents.variantUpdate, this.updatePackSpec);
  }

  /**
   * Updates the pack spec value for the selected variant.
   * @param {VariantUpdateEvent} event - The variant update event.
   */
  updatePackSpec = (event) => {
    const variant = event.detail.resource;
    if (!variant) return;

    let map;
    try {
      map = JSON.parse(this.dataset.map || '{}');
    } catch {
      return;
    }

    const value = map[variant.id];
    const row = this.closest('tr');

    if (value == null) {
      if (row) row.hidden = true;
      return;
    }

    if (row) row.hidden = false;
    this.textContent = value;
  };
}

if (!customElements.get('pack-spec')) {
  customElements.define('pack-spec', PackSpec);
}
